<div class="container-fluid">
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title>{{ isEditMode ? 'Editar centro de trabajo' : 'Nuevo centro de trabajo' }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        
        <h3>Información básica</h3>
        <div class="row">
          <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Nombre</mat-label>
              <input matInput formControlName="name" placeholder="Nombre del centro de trabajo">
              <mat-error *ngIf="form.get('name')?.hasError('required')">
                El nombre es requerido
              </mat-error>
              <mat-error *ngIf="form.get('name')?.hasError('maxlength')">
                Máximo 200 caracteres
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Slug</mat-label>
              <input matInput formControlName="slug" placeholder="slug-de-la-ubicacion">
              <mat-error *ngIf="form.get('slug')?.hasError('required')">
                El slug es requerido
              </mat-error>
              <mat-error *ngIf="form.get('slug')?.hasError('maxlength')">
                Máximo 200 caracteres
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-md-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Descripción</mat-label>
              <textarea matInput formControlName="description" placeholder="Descripción del centro de trabajo" rows="3"></textarea>
              <mat-error *ngIf="form.get('description')?.hasError('maxlength')">
                Máximo 500 caracteres
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <mat-divider class="my-3"></mat-divider>

        <h3>Dirección</h3>
        <div class="row">
          <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Dirección línea 1</mat-label>
              <input matInput formControlName="addressLine1" placeholder="Calle, número">
              <mat-error *ngIf="form.get('addressLine1')?.hasError('maxlength')">
                Máximo 200 caracteres
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Dirección línea 2</mat-label>
              <input matInput formControlName="addressLine2" placeholder="Piso, puerta">
              <mat-error *ngIf="form.get('addressLine2')?.hasError('maxlength')">
                Máximo 200 caracteres
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-md-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Ciudad</mat-label>
              <input matInput formControlName="city" placeholder="Ciudad">
              <mat-error *ngIf="form.get('city')?.hasError('maxlength')">
                Máximo 100 caracteres
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-md-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Provincia/Estado</mat-label>
              <input matInput formControlName="state" placeholder="Provincia o estado">
              <mat-error *ngIf="form.get('state')?.hasError('maxlength')">
                Máximo 100 caracteres
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-md-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Código postal</mat-label>
              <input matInput formControlName="postalCode" placeholder="28001">
              <mat-error *ngIf="form.get('postalCode')?.hasError('maxlength')">
                Máximo 20 caracteres
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Código de país</mat-label>
              <input matInput formControlName="countryCode" placeholder="ES" maxlength="2">
              <mat-error *ngIf="form.get('countryCode')?.hasError('required')">
                El código de país es requerido
              </mat-error>
              <mat-error *ngIf="form.get('countryCode')?.hasError('maxlength')">
                Máximo 2 caracteres
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <mat-divider class="my-3"></mat-divider>

        <h3>Configuración</h3>
        <div class="row">
          <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Zona horaria</mat-label>
              <input matInput formControlName="timeZoneId" placeholder="Europe/Madrid">
              <mat-error *ngIf="form.get('timeZoneId')?.hasError('required')">
                La zona horaria es requerida
              </mat-error>
              <mat-error *ngIf="form.get('timeZoneId')?.hasError('maxlength')">
                Máximo 100 caracteres
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Código de moneda</mat-label>
              <input matInput formControlName="currencyCode" placeholder="EUR" maxlength="3">
              <mat-error *ngIf="form.get('currencyCode')?.hasError('maxlength')">
                Máximo 3 caracteres
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Teléfono</mat-label>
              <input matInput formControlName="phone" placeholder="+34 912 345 678">
              <mat-error *ngIf="form.get('phone')?.hasError('maxlength')">
                Máximo 20 caracteres
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Email</mat-label>
              <input matInput formControlName="email" placeholder="contacto@centrotrabajo.com" type="email">
              <mat-error *ngIf="form.get('email')?.hasError('email')">
                Email inválido
              </mat-error>
              <mat-error *ngIf="form.get('email')?.hasError('maxlength')">
                Máximo 100 caracteres
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Estado</mat-label>
              <mat-select formControlName="status">
                <mat-option value="Active">Activo</mat-option>
                <mat-option value="Inactive">Inactivo</mat-option>
              </mat-select>
              <mat-error *ngIf="form.get('status')?.hasError('required')">
                El estado es requerido
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Orden de visualización</mat-label>
              <input matInput formControlName="displayOrder" type="number" placeholder="0">
              <mat-error *ngIf="form.get('displayOrder')?.hasError('min')">
                Debe ser mayor o igual a 0
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-md-12">
            <mat-checkbox formControlName="isMainLocation">
              Centro de trabajo principal
            </mat-checkbox>
          </div>
        </div>

        <mat-divider class="my-3"></mat-divider>

        <div class="d-flex justify-content-end mt-3">
          <button mat-button type="button" (click)="onCancel()" class="me-2">
            Cancelar
          </button>
          <button mat-raised-button color="primary" type="submit" [disabled]="form.invalid || (isLoading$ | async)">
            {{ isEditMode ? 'Actualizar' : 'Crear' }}
          </button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>
